import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import axios from "axios";
import {
  myProjectApi,
  getReferenceProjectApi,
  getCheckListApi,
  getFieldCheckApi,
  getQuotationListApi,
  AddCopiedCountApi,
  updateContainerValueApi,
  updateContainerApi,
  updateFieldCheckApi,
  createFieldCheckApi,
  deleteFieldCheckApi,
  fieldCheckReferenceListApi,
  createItemReviewApi,
  updateItemReviewApi,
  deleteItemReviewApi,
  updateContainerAllApi,
} from "../../api";
import {
  addCopiedCountRequest,
  getfieldCheckListRequest,
  getQuotationRequest,
  initializeIPProject,
  IPProject,
  MyProjectRequest,
  newIPProject,
  updateContainerAllRequest,
  updateContainerRequest,
  updateContainerValueRequest,
} from "../../models/IPProject";
import { IPItemValue, IPItemValueRequest } from "../../models/IPItemValue";
import { IPManualPoint } from "../../models/IPManualPoint";
import {
  CheckListRequest,
  FieldCheck,
  SearchFieldCheckListRequest,
  FieldCheckRequest,
  IPFieldCheck,
  InitializeIPFieldCheck,
} from "../../models/IPFieldCheck";
import { initializeIPItemReview, IPItemReview, ItemReviewDeleteRequest, ItemReviewRequest } from "../../models/IPItemReview";
import { IPContainerValue } from "../../models/IPContainerValue";
import IPUtility from "../../classes/IPUtility";
import { IPContainer } from "../../models/IPContainer";
import IPConstants from "../../classes/IPConstants";
export const getMyProject = createAsyncThunk(
  "/myProject",
  async (params: MyProjectRequest) => {
    try {
      const requestParams: MyProjectRequest = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(myProjectApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
export const getReferenceProject = createAsyncThunk(
  "/GetReferenceProject",
  async (params: IPItemValueRequest) => {
    try {
      const requestParams: IPItemValueRequest = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(getReferenceProjectApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
export const getCheckList = createAsyncThunk(
  "/GetCheckList",
  async (params: Partial<CheckListRequest>) => {
    try {
      const requestParams: Partial<CheckListRequest> = {
        userToken: params.userToken,
        id: params.id,
        pid: params.pid,
        page: params.page,
        rowCount: params.rowCount,
      };
      return await axios
        .post(getCheckListApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
export const getFieldCheck = createAsyncThunk(
  "/getFieldCheck",
  async (params: FieldCheck) => {
    try {
      const requestParams: FieldCheck = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(getFieldCheckApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
// note 2022-02-12 SmokingScully 추가
export const deleteFieldCheck = createAsyncThunk(
  "/deleteFieldCheck",
  async (params: FieldCheck) => {
    try {
      const requestParams: FieldCheck = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(deleteFieldCheckApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            if (params.successHandler) params.successHandler();
          }
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-02-06 SmokingScully 추가
export const updateFieldCheck = createAsyncThunk(
  "/updateFieldCheck",
  async (params: FieldCheckRequest) => {
    try {
      const requestParams: FieldCheckRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(updateFieldCheckApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          IPUtility.log(data);
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            if (params.successHandler) params.successHandler(data.item);
          } else if (params.failHandler) params.failHandler();
        });
    } catch (error) {
      if (params.failHandler) params.failHandler();
      throw new Error("네트워크 에러");
    }
  }
);
// note 2022-02-06 SmokingScully 추가
export const createFieldCheck = createAsyncThunk(
  "/createFieldCheck",
  async (params: FieldCheckRequest) => {
    try {
      const requestParams: FieldCheckRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(createFieldCheckApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          IPUtility.log(data);
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            if (params.successHandler) params.successHandler(data.item);
          } else if (params.failHandler) params.failHandler();
        });
    } catch (error) {
      if (params.failHandler) params.failHandler();
      throw new Error("네트워크 에러");
    }
  }
);
// note 2022-02-19 SmokingScully 추가
export const fieldCheckReferenceList = createAsyncThunk(
  "/fieldCheckReferenceList",
  async (params: SearchFieldCheckListRequest) => {
    try {
      const requestParams: SearchFieldCheckListRequest = {
        userToken: params.userToken,
        searchWord: params.searchWord,
      };
      return await axios
        .post(fieldCheckReferenceListApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-03-01 SmokingScully 추가
export const createItemReview = createAsyncThunk(
  "/createItemReview",
  async (params: ItemReviewRequest) => {
    try {
      const requestParams: ItemReviewRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      IPUtility.log(params);
      return await axios
        .post(createItemReviewApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          IPUtility.log(data);
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            if (params.successHandler) params.successHandler(data.item);
          } else if (params.failHandler) params.failHandler();
        });
    } catch (error) {
      if (params.failHandler) params.failHandler();
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-03-01 SmokingScully 추가
export const updateItemReview = createAsyncThunk(
  "/updateItemReview",
  async (params: ItemReviewRequest) => {
    try {
      const requestParams: ItemReviewRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      // IPUtility.log(params);
      return await axios
        .post(updateItemReviewApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          // IPUtility.log(data);
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            if (params.successHandler) params.successHandler(data.item);
          } else if (params.failHandler) params.failHandler();
        });
    } catch (error) {
      if (params.failHandler) params.failHandler();
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-02-12 SmokingScully 추가
export const deleteItemReview = createAsyncThunk(
  "/deleteItemReview",
  async (params: ItemReviewDeleteRequest) => {
    try {
      const requestParams: ItemReviewDeleteRequest = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(deleteItemReviewApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            if (params.successHandler) params.successHandler();
          }
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

export const getQuotationList = createAsyncThunk(
  "/getQuotationList",
  async (params: getQuotationRequest) => {
    try {
      const requestParams: getQuotationRequest = {
        userToken: params.userToken,
        searchWord: params.searchWord,
        id: params.id,
        preYear: params.preYear,
        type: params.type,
      };
      return await axios
        .post(getQuotationListApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
export const addCopiedCount = createAsyncThunk(
  "/addCopiedCount",
  async (params: addCopiedCountRequest) => {
    try {
      const requestParams: addCopiedCountRequest = {
        userToken: params.userToken,
        id: params.id,
        type: params.type,
      };
      return await axios
        .post(AddCopiedCountApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-02-04 SmokingScully 추가
export const updateContainerValue = createAsyncThunk(
  "/updateContainerValue",
  async (params: updateContainerValueRequest) => {
    try {
      const requestParams: updateContainerValueRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(updateContainerValueApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

export const updateContainerAll =  createAsyncThunk(
  "/updateContainerAll",
  async (params: updateContainerAllRequest) => {
    var isSavedSuccess: boolean = false;
    try {
      const requestParams: updateContainerAllRequest = {
        userToken: params.userToken,
        items: params.items,
        points: params.points,
        projectUID: params.projectUID,
        noContentItemUIDs: params.noContentItemUIDs,
      };
      IPUtility.log(requestParams);
      return await axios
        .post(updateContainerAllApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            isSavedSuccess = true;
            if (params.successHandler) params.successHandler();
          }
          else if (!data.isAuth) {
            isSavedSuccess = false;
            if (params.authFailHandler) params.authFailHandler();
          }
          else {
            isSavedSuccess = false;
            if (params.failHandler) params.failHandler();
          }
          // IPUtility.updateContainerToLocal(params.item, isSavedSuccess);
        });
    } catch (error) {
      IPUtility.log(error);
      if (params.failHandler) params.failHandler();
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-02-04 SmokingScully 추가
export const updateContainer = createAsyncThunk(
  "/updateContainer",
  async (params: updateContainerRequest) => {
    var isSavedSuccess: boolean = false;
    try {
      const requestParams: updateContainerRequest = {
        userToken: params.userToken,
        item: params.item,
        points: params.points,
        projectUID: params.projectUID,
        noContentItemUIDs: params.noContentItemUIDs,
      };
      IPUtility.log(requestParams);
      return await axios
        .post(updateContainerApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (data !== undefined && data.message.indexOf(IPConstants.successMessage) > -1) {
            //setServerSavedAction(true);
            isSavedSuccess = true;
            if (params.successHandler) params.successHandler();
          }
          else if (!data.isAuth) {
            //setServerSavedAction(false);
            isSavedSuccess = false;
            if (params.authFailHandler) params.authFailHandler();
          }
          else {
            //setServerSavedAction(false);
            isSavedSuccess = false;
            if (params.failHandler) params.failHandler();
          }
          // IPUtility.updateContainerToLocal(params.item, isSavedSuccess);
          IPUtility.updateContainerToLocal(params.item, isSavedSuccess);
        });
    } catch (error) {
      IPUtility.log(error);
      if (params.failHandler) params.failHandler();
      throw new Error("네트워크 에러");
    }
  }
);

type quotationFilteringType = {
  preYear: number;
  type: number;
};

interface MyProject {
  loading: boolean;
  myProject: IPProject;
  getReference: IPProject[];
  fieldCheckList: IPFieldCheck[];
  fieldCheck: IPFieldCheck;
  error: string;
  maxPage: number;
  message: string;
  isAuth: boolean;
  isGuideShow: boolean;
  currentUid: number;
  categoriesName: string;
  containerName: string;
  selectCategory: number;
  selectContainer: number;
  selectItem: number;
  itemName: string;
  isChecked: boolean; // note FieldCheck 해당없음 여부
  selectReferenceProject: number;
  quotationFiltering: quotationFilteringType;
  itemValue: IPItemValue;
  searchItemValues: IPItemValue[];
  searchFieldChecks: IPFieldCheck[];
  checked: boolean;
  isSaving: boolean;
  myProjectTableHeader: string[];
  EditProjectTableHeader: string[];
  checkListTableHeader: string[];
  quotationListTableHeader: string[];
  isSavedToServer: number;
  saveTime: Date;
}

const initialState: MyProject = {
  loading: false,
  myProject: { ...newIPProject() },
  getReference: [] as IPProject[],
  fieldCheckList: [],
  fieldCheck: {} as IPFieldCheck,
  error: "",
  maxPage: 0,
  message: "",
  isAuth: false,
  isGuideShow: true,
  currentUid: 0,
  categoriesName: "",
  containerName: "",
  selectCategory: 0,
  selectContainer: 0,
  selectItem: 0,
  itemName: "",
  isChecked: false,
  selectReferenceProject: 0,
  quotationFiltering: {
    preYear: 0,
    type: 0,
  },
  itemValue: {} as IPItemValue,
  searchItemValues: [] as IPItemValue[],
  searchFieldChecks: [] as IPFieldCheck[],
  checked: false,
  isSaving: false,
  myProjectTableHeader: [
    "대분류명",
    "중분류",
    "제외여부",
    "평가점수",
    "작성된 항목",
    "내 항목",
  ],
  EditProjectTableHeader: ["항목", "점수", "작성내용", "가이드"],
  checkListTableHeader: [
    "ID",
    "공정명",
    "항목",
    "위치(설비명)",
    "사진1",
    "사진2",
    "편집",
  ],
  quotationListTableHeader: ["분류", "내용", "인용횟수"],
  isSavedToServer: 0,
  saveTime: new Date(),
};

type EditPayload = {
  category: string;
  container: string;
};

type selectItemPayload = {
  uid: number;
  name: string;
};

type writtenContentPayload = {
  itemUid: number;
  general: string;
  regulation: string;
  instruction: string;
  recommendation: string;
};
const writtenContent: writtenContentPayload = {
  itemUid: 0,
  general: "",
  regulation: "",
  instruction: "",
  recommendation: "",
};

const myProjectSlice = createSlice({
  name: "myProject",
  initialState,
  reducers: {
    currentUidAction: (state, { payload }: PayloadAction<number>): void => {
      state.currentUid = payload;
    },

    deleteReferenceAction: (state, { payload }) => {
      const filtering = state.getReference.filter(
        (project) => project.uid !== payload
      );
      state.getReference = [...filtering];
    },

    editProjectNamedAction: (
      state,
      { payload: { category, container } }: PayloadAction<EditPayload>
    ) => {
      state.categoriesName = category;
      state.containerName = container;
    },

    //마이프로젝트 카테고리 uid 선택
    selectCategoryAction: (state, { payload }: PayloadAction<number>) => {
      state.selectCategory = payload;
    },

    //마이프로젝트 컨테이너 uid 선택
    selectContainerAction: (state, { payload }: PayloadAction<number>) => {
      state.selectContainer = payload;
    },
    //마이프로젝트 아이템 uid 선택
    selectItemAction: (state, { payload }: PayloadAction<selectItemPayload>) => {
      state.selectItem = payload.uid;
      state.itemName = payload.name;
    },

    // selectFieldCheck

    //가이드 프로젝트 uid 선택
    selectReferenceAction: (state, { payload }: PayloadAction<number>) => {
      state.selectReferenceProject = payload;
      // console.log(state.selectReferenceProject);
    },

    quotationFilteringAction: (
      state,
      { payload }: PayloadAction<quotationFilteringType>
    ) => {
      state.quotationFiltering = payload;
    },

    setManualPointAction: (state, { payload }: PayloadAction<IPManualPoint>) => {
      const index = state.myProject.manualPointsList.findIndex(x => x.itemUID === payload.itemUID);
      if (index > -1) { state.myProject.manualPointsList[index] = payload; }
      else { state.myProject.manualPointsList.push(payload); }
    },

    setNoContentAction: (state, { payload }: PayloadAction<number[]>) => {
      state.myProject.noContentItemUIDs = payload;
    },

    //해당사항없음
    checkAction: (state, { payload }) => {
      const index = state.myProject.noContentItemUIDs.indexOf(payload.uid);
      if (payload.isChecked) {
        if (index === -1) state.myProject.noContentItemUIDs.push(payload.uid);
      }
      else {
        if (index > -1) state.myProject.noContentItemUIDs.splice(index, 1);
      }
    },

    //2022-01-19 editProject textarea 입력관련 action추가
    recordContentsAction: (
      state,
      { payload = writtenContent }: PayloadAction<Partial<writtenContentPayload>>
    ) => {
      state.selectItem = payload.itemUid!;
      const findItem = state.myProject.categories
        .find((category) => category.uid === state.selectCategory)
        ?.containers.find(
          (container) => container.uid === state.selectContainer
        )
        ?.items.find((item) => item.uid === state.selectItem)!;

      findItem.myItemValue.general = payload.general!;
      findItem.myItemValue.regulation = payload.regulation!;
      findItem.myItemValue.instruction = payload.instruction!;
      findItem.myItemValue.recommendation = payload.recommendation!;
    },

    //프로젝트 작성 아이템 벨류값
    writtenContentsAction: (
      state,
      { payload }: PayloadAction<Partial<writtenContentPayload>>
    ) => {
      state.selectItem = payload.itemUid!;
      // const findItem = state.myProject.categories
      //   .find((category) => category.uid === state.selectCategory)
      //   ?.containers.find(
      //     (container) => container.uid === state.selectContainer
      //   )
      //   ?.items.find((item) => item.uid === state.selectItem)!;
      const findItem = IPUtility.getItemByUIDs(state.myProject, payload.itemUid as number);
      if (payload.general !== undefined) {
        findItem.myItemValue.general = payload.general;
      } else if (payload.regulation !== undefined) {
        findItem.myItemValue.regulation = payload.regulation;
      } else if (payload.instruction !== undefined) {
        findItem.myItemValue.instruction = payload.instruction;
      } else if (payload.recommendation !== undefined) {
        findItem.myItemValue.recommendation = payload.recommendation;
      }
    },

    updateGeneralContent: (state, { payload }: PayloadAction<Partial<writtenContentPayload>>) => {
      const itemUID = payload.itemUid as number;
      state.selectItem = itemUID;
      const findItem = IPUtility.getItemByUIDs(state.myProject, payload.itemUid as number);
      findItem.myItemValue.general = payload.general as string;
    },
    updateRecommendationContent: (state, { payload }: PayloadAction<Partial<writtenContentPayload>>) => {
      const itemUID = payload.itemUid as number;
      state.selectItem = itemUID;
      const findItem = IPUtility.getItemByUIDs(state.myProject, payload.itemUid as number);
      findItem.myItemValue.recommendation = payload.recommendation as string;
    },
    updateInstructionContent: (state, { payload }: PayloadAction<Partial<writtenContentPayload>>) => {
      const itemUID = payload.itemUid as number;
      state.selectItem = itemUID;
      const findItem = IPUtility.getItemByUIDs(state.myProject, payload.itemUid as number);
      findItem.myItemValue.instruction = payload.instruction as string;
    },
    updateRegulationContent: (state, { payload }: PayloadAction<Partial<writtenContentPayload>>) => {
      const itemUID = payload.itemUid as number;
      state.selectItem = itemUID;
      const findItem = IPUtility.getItemByUIDs(state.myProject, payload.itemUid as number);
      findItem.myItemValue.regulation = payload.regulation as string;
    },
    // FieldCheck
    altFieldCheckImproveAction: (state, { payload }: PayloadAction<{ type: number, text: string, handler?: any }>) => {
      IPUtility.log("Before");
      IPUtility.log(state.fieldCheck.notice);
      switch (payload.type) {
        case 0: state.fieldCheck.notice = payload.text; break;
        case 1: state.fieldCheck.improve = payload.text; break;
        case 2: state.fieldCheck.regulation = payload.text; break;
      }
      IPUtility.log("After");
      IPUtility.log(state.fieldCheck.notice);
      if (payload.handler) payload.handler();
    },

    resetFieldCheckAction: (state) => {
      state.fieldCheck = { ...InitializeIPFieldCheck, processName: state.myProject?.processNamesSerial?.split(',')[0].trim(), };
    },

    // note 2022-02-04 SmokingScully 추가
    // 프로젝트 제외
    containerValueActions: (
      state,
      { payload = {} as IPContainerValue }: PayloadAction<IPContainerValue>
    ) => {
      const findValue = IPUtility.getContainerByUID(state.myProject, payload.containerUID).containerValue;
      findValue.isExclude = payload.isExclude;
    },

    // note 2022-03-01 SmokingScully 추가
    // ProjectReview 재조정
    addReviewsActions: (state, { payload }: PayloadAction<IPItemReview>) => {
      if (payload.isMeeting) state.myProject.meetingReviews.push(payload);
      else state.myProject.evalReviews.push(payload);
    },

    updateReviewsActions: (state, { payload }: PayloadAction<IPItemReview>) => {
      if (payload.isMeeting) {
        const index = state.myProject.meetingReviews.findIndex(x => x.uid === payload.uid);
        if (index > -1) state.myProject.meetingReviews[index] = payload;
      }
      else {
        const index = state.myProject.evalReviews.findIndex(x => x.uid === payload.uid);
        if (index > -1) state.myProject.evalReviews[index] = payload;
      }
    },

    deleteReviewsActions: (state, { payload }: PayloadAction<{ uid: number, isMeeting: boolean }>) => {
      if (payload.isMeeting) {
        const index = state.myProject.meetingReviews.findIndex(x => x.uid === payload.uid);
        if (index > -1) state.myProject.meetingReviews.splice(index, 1);
      }
      else {
        const index = state.myProject.evalReviews.findIndex(x => x.uid === payload.uid);
        if (index > -1) state.myProject.evalReviews.splice(index, 1);
      }
    },

    GuideToggleAction: (state) => {
      state.isGuideShow = !state.isGuideShow;
    },

    replaceMyProjectAction: (state, { payload }: PayloadAction<IPProject>) => {
      state.myProject = payload;
      state.currentUid = payload.uid;
      state.selectCategory = payload.categories[0].uid;
      state.selectContainer = payload.categories[0].containers[0].uid;
      state.categoriesName = payload.categories[0].name;
      state.containerName = payload.categories[0].containers[0].name;
      state.selectItem = payload.categories[0].containers[0].items[0].uid;
    },

    setServerSavedAction: (state, { payload }: PayloadAction<number>) => {
      state.isSavedToServer = payload;
      state.saveTime = new Date();
    },
  },

  extraReducers: {
    [getMyProject.pending.type]: (state) => {
      state.loading = true;
    },
    [getMyProject.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.myProject = action.payload.item;
      state.maxPage = action.payload.maxPage;
      state.message = action.payload.message;
      state.isSavedToServer = 0;
      IPUtility.saveProjectToLocal(action.payload.item, true);
      // console.log(state.myProject);
    },
    [getMyProject.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error?.message;
    },

    [getReferenceProject.pending.type]: (state) => {
      state.loading = true;
    },
    [getReferenceProject.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.getReference = [...state.getReference, action.payload.item];
      state.message = action.payload.message;
      state.isAuth = action.payload.isAuth;
      // console.log(state.getReference);
    },
    [getReferenceProject.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [getCheckList.pending.type]: (state) => {
      state.loading = true;
    },
    [getCheckList.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.fieldCheckList = action.payload.items;
      state.message = action.payload.message;
      state.isAuth = action.payload.isAuth;
    },
    [getCheckList.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [fieldCheckReferenceList.pending.type]: (state) => {
      state.loading = true;
    },
    [fieldCheckReferenceList.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.searchFieldChecks = action.payload.items;
      state.message = action.payload.message;
      state.isAuth = action.payload.isAuth;
    },
    [fieldCheckReferenceList.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [getFieldCheck.pending.type]: (state) => {
      state.loading = true;
    },
    [getFieldCheck.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.fieldCheck = action.payload.item;
      state.message = action.payload.message;
      state.isAuth = action.payload.isAuth;
    },
    [getFieldCheck.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [createFieldCheck.pending.type]: (state) => {
      state.loading = true;
    },
    [createFieldCheck.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.fieldCheck = { ...InitializeIPFieldCheck, processName: state.myProject?.processNamesSerial?.split(',')[0].trim(), };
      if (action.payload) {
        if (action.payload.message) state.message = action.payload.message;
        state.isAuth = action.payload.isAuth;
      }
    },
    [createFieldCheck.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [updateFieldCheck.pending.type]: (state) => {
      state.loading = true;
    },
    [updateFieldCheck.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.fieldCheck = { ...InitializeIPFieldCheck, processName: state.myProject?.processNamesSerial?.split(',')[0].trim(), };
      state.message = action.payload?.message;
      state.isAuth = action.payload?.isAuth;
    },
    [updateFieldCheck.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },


    [getQuotationList.pending.type]: (state) => {
      state.loading = true;
    },
    [getQuotationList.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.searchItemValues = action.payload.items;
      state.message = action.payload.message;
      state.isAuth = action.payload.isAuth;
    },
    [getQuotationList.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [addCopiedCount.pending.type]: (state) => {
      state.loading = true;
    },
    [addCopiedCount.fulfilled.type]: (state, action) => {
      state.loading = false;
    },
    [addCopiedCount.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [updateContainer.pending.type]: (state) => {
      state.loading = true;
    },
    [updateContainer.fulfilled.type]: (state, action) => {
      state.loading = false;
    },
    [updateContainer.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
  },
});

export const {
  currentUidAction,
  deleteReferenceAction,
  editProjectNamedAction,
  selectCategoryAction,
  selectContainerAction,
  selectItemAction,
  selectReferenceAction,
  writtenContentsAction,
  updateGeneralContent,
  updateRegulationContent,
  updateInstructionContent,
  updateRecommendationContent,
  // pasteContentsAction,
  // itemReviewActions, // note 2022-02-04 SmokingScully 추가
  containerValueActions, // note 2022-02-04 SmokingScully 추가
  altFieldCheckImproveAction,
  resetFieldCheckAction,
  addReviewsActions,
  updateReviewsActions,
  deleteReviewsActions,
  recordContentsAction,
  checkAction,
  GuideToggleAction,
  quotationFilteringAction,
  setManualPointAction,
  replaceMyProjectAction,
  setServerSavedAction,
} = myProjectSlice.actions;

export default myProjectSlice.reducer;
